import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const NewChevronLeft: FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 11 22" height="30px" fill={props.fill || 'alabaster'} transform="scale(-1,1)" {...props}>
      <path d="M3.6 21.2.4 18.7l6-7.8-6-7.8L3.6.6l6 7.8c1.1 1.4 1.1 3.5 0 4.9l-6 7.9z" />
    </Icon>
  )
}
export default NewChevronLeft
